import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const savedToken = localStorage.getItem("inv_token");
if (savedToken) axios.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("inv_token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("inv_token");
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const api = {
  login: (username, password) =>
    axios.post(`${API}/auth/login`, { username, password }).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`).then((r) => r.data),
  getCatalog: () => axios.get(`${API}/catalog`).then((r) => r.data),
  addProduct: (payload) => axios.post(`${API}/products`, payload).then((r) => r.data),
  getActive: () => axios.get(`${API}/inventories/active`).then((r) => r.data),
  listInventories: () => axios.get(`${API}/inventories`).then((r) => r.data),
  getInventory: (id) => axios.get(`${API}/inventories/${id}`).then((r) => r.data),
  getCounts: (id) => axios.get(`${API}/inventories/${id}/counts`).then((r) => r.data),
  createInventory: (name, username) =>
    axios.post(`${API}/inventories`, { name, username }).then((r) => r.data),
  closeInventory: (id) => axios.post(`${API}/inventories/${id}/close`).then((r) => r.data),
  reopenInventory: (id) => axios.post(`${API}/inventories/${id}/reopen`).then((r) => r.data),
  updateCount: (id, payload) =>
    axios.put(`${API}/inventories/${id}/count`, payload).then((r) => r.data),
  exportUrl: (id) => `${API}/inventories/${id}/export`,
};
